import React from "react";
import { Container, Header, Grid } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import CardMenu, { ICardMenu } from "../CardMenu";

interface ITemplateIndexProps {
    title: string;
    cards: ICardMenu[];
}

const TemplateIndex: React.FC<ITemplateIndexProps> = ({ title, cards }) => {
    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                <Header dividing as="h1" size="huge">
                    {title}
                </Header>
                <Grid columns={4} centered doubling>
                    {cards.map((card, index) => (
                        <CardMenu
                            key={`app-card-menu-${index}`}
                            path={card.path}
                            icon={card.icon}
                            corner={card.corner}
                            text={card.text}
                            roles={card.roles}
                            show={card.show}
                        />
                    ))}
                </Grid>
            </Container>
            <Footer />
        </>
    );
};

export default TemplateIndex;
